import React from 'react';
import pluralize from 'pluralize';
import styles from './styles.scss';
import TakeExamButton from '../TakeExamButton';

const ExamTile = (props) => {
  const {
    title,
    iconClass,
    length,
    cta: passedCta,
    product,
    variant,
    remaining,
    remainingWord = 'exam',
    disabled,
  } = props;

  const cta = passedCta || (
    <TakeExamButton
      disabled={disabled || remaining === 0}
      product={product}
      variant={variant}
    />
  );

  const remainingText = (() => {
    if (remaining === -1) {
      return 'Randomized exam; unlimited takes';
    }

    if (!remaining) {
      return `You've taken all these ${pluralize(remainingWord)}`;
    }

    return `${pluralize(remainingWord, remaining, true)} left to take`;
  })();

  return (
    <div className={styles.tile}>
      <div className={styles.tileTitle}>{title}</div>
      <div className={styles.tileLength}>{length}</div>
      <div className={styles.tileIcon}>
        <i className={iconClass} />
      </div>
      <div className={styles.tileRemaining}>{remainingText}</div>
      <div className={styles.tileCta}>{cta}</div>
    </div>
  );
};

export default ExamTile;
